import { sendLoginStateEvents } from './../../AlmeApp/initialize/loginState';
export async function processLiveChatEndAction(response, almeState, setAlmeState, appConfig, almeApiUtils) {
    if (almeState.isLiveChatConnected && (response === null || response === void 0 ? void 0 : response.responseActions)) {
        for (const action of response.responseActions) {
            if (action.Name === "LiveChatEnd") {
                if (appConfig.main.isLoggedIn && !almeState.isLoggedIn) {
                    const loggedInState = await sendLoginStateEvents(appConfig, almeApiUtils, almeState);
                    setAlmeState(Object.assign(Object.assign({}, almeState), { isLoggedIn: loggedInState.isLoggedIn, clientSessionId: loggedInState.clientSessionId, isLiveChatConnected: false }));
                }
                else {
                    setAlmeState(Object.assign(Object.assign({}, almeState), { isLiveChatConnected: false }));
                }
                return;
            }
        }
    }
}
